
import { defineComponent } from "vue";
export default defineComponent({
  props: {
    hideNavigationItem: {
      type: Boolean,
      default: false,
    }
  },
});
